import { FormattedMessage } from "react-intl"
import { Link } from "react-router-dom"

export const Fullfilled = ({ title }: { title?: string }) => {
  return (
    <div className="fullfilled">
      <h1>{title ?? <FormattedMessage id="ex-completed" />}</h1>
      <p>
        <FormattedMessage id="exchange-done" />
      </p>
      <div className="max-w-[100%] text-left">
        <p>
          **{" "}
          <FormattedMessage
            id="order-section"
            values={{
              b: (chunk) => (
                <span className="text-main-main">
                  <Link to="/transactions/exchange" className="hover:!underline">
                    {chunk}
                  </Link>
                </span>
              ),
            }}
          />
        </p>
      </div>
    </div>
  )
}
